import CartFlights from './CartFlights';

export default CartFlights;
